import { FileRejection } from '@mantine/dropzone';

import { FileSelection } from './fileUploadState';

export type FileData = FileSelection | FileRejection;

export const isFileSelection = (x: FileData): x is FileSelection => {
  return 'uploadState' in x;
};
